module.exports = __webpack_public_path__ + "media/images/vanguard-f085afea744580e5e70712e75a41153a.png";